var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.$ct( _vm.isAdmin ? 'adminTitle' : 'jobRecommendations')))]),_c('ul',{attrs:{"role":"list"}},[_vm._l((_vm.recommendations),function(recommendation){return [_c('li',{key:recommendation},[_vm._v(" "+_vm._s(_vm.$t(`jobs.${recommendation}`))+" ")])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }